export const LOAN_STATUS_LABELS = {
  BOARDED: 'Boarded',
  DELINQUENT: 'Delinquent',
  CLOSED: 'Closed',
};

const LOAN_STATUS_LABEL_BY_STATUS = new Map(Object.entries(LOAN_STATUS_LABELS));

export const findLoanStatusLabel = (status: string): string | undefined => LOAN_STATUS_LABEL_BY_STATUS.get(status);

export const formatLoanStatus = (status: string | null | undefined): string =>
  status ? (findLoanStatusLabel(status) ?? status) : '—';
